import { useEffect } from 'react';
import { useStateValue } from '../..';
import { apiWithOrg } from 'services/api';
import {
  fetchUnpaidTickets,
  fetchUnpaidTicketsSuccess,
  fetchUnpaidTicketsFailure,
} from '../actions';
import useOrganisation from 'state/organisation/hooks/useOrganisation';
interface ITicketResponse {
  resultCode: string;
  resultReason: string | null;
  data: Array<{
    resultCode: string | null;
    resultReason: string | null;
    orderId: string;
    type: string;
    status: string;
    orderNumber: string;
    customerId: number;
    customerType: string;
    dateCreated: string;
    lastUpdateAt: string;
    total: string;
    cashDrawerName?: string;
    historyResults: Array<{
      status: string;
      description: string;
      date: string;
      user: string;
      userId: string;
      employeeNumber: string;
    }>;
    customer: {
      id: number;
      firstName: string;
      lastName: string;
      nickName: string | null;
      middleName: string | null;
      phone: string | null;
      email: string;
      status: string;
    };
    paymentStatus: string;
  }>;
}
const useUnpaidTickets = () => {
  const { organisation } = useOrganisation();
  const { activeOrg } = organisation;
  const { state, dispatch } = useStateValue();
  const { ticket } = state;

  const fetchTickets = async () => {
    dispatch(fetchUnpaidTickets());
    try {
      const baseUrl = activeOrg?.settings.sell_treez_url;
      const url = baseUrl?.startsWith('http://') || baseUrl?.startsWith('https://') 
        ? baseUrl 
        : `https://${baseUrl}`;
      
      const response = await apiWithOrg.get<ITicketResponse>(
        `${url}/HintsService/v1.0/rest/ecommerce/tickets`
      );
      
      const unpaidTickets = response.data.data
        .filter(
          (ticketItem) =>
            ticketItem.paymentStatus === 'UNPAID' &&
            ticketItem.status !== 'COMPLETE'
        )
        .map((ticketItem) => ({
          orderId: ticketItem.orderId,
          orderNumber: ticketItem.orderNumber,
          customerName: ticketItem.customer
            ? `${ticketItem.customer.firstName || ''} ${
                ticketItem.customer.lastName || ''
              }`.trim()
            : 'N/A',
          customerPhone: ticketItem.customer?.phone || '',
          customerEmail: ticketItem.customer?.email || '',
          grossAmount: parseFloat(ticketItem.total) * 100,
          orderType: ticketItem.type,
          packedBy:
            ticketItem.historyResults?.find(
              (history) => history.status === ticketItem.status
            )?.user || 'N/A',
          dateCreated: ticketItem.dateCreated,
          status: ticketItem.status,
          cashDrawerName: ticketItem.cashDrawerName,
        }))
        .sort(
          (a, b) =>
            new Date(b.dateCreated).getTime() -
            new Date(a.dateCreated).getTime()
        );

      dispatch(fetchUnpaidTicketsSuccess(unpaidTickets));
    } catch (error) {
      dispatch(fetchUnpaidTicketsFailure(error));
    }
  };

  return {
    unpaidTickets: ticket.unpaidTickets,
    isLoading: ticket.isLoading > 0,
    ticket,
    error: ticket.error,
    fetchTickets,
  };
};

export default useUnpaidTickets;
